import { Helmet } from "react-helmet-async";

import { AppProvider } from "@/providers/app";
import { AppRoutes } from "@/routes";

export const App = () => {
  return (
    <AppProvider>
      <Helmet
        titleTemplate={`%s - ${import.meta.env.VITE_TITLE}`}
        defaultTitle={import.meta.env.VITE_TITLE}
      />
      <AppRoutes />
    </AppProvider>
  );
};
